export const Comps2 = [
  {
    id: 0,
    name: "Astral",
    img: "Astral.png",
    compsize: 8,
    champions: [
      "Nidalee",
      "Skarner",
      "Vladmir",
      "Lux",
      "Varus",
      "Aurelion Sol",
    ],
  },
  {
    id: 1,
    name: "Darkflight",
    img: "Darkflight.png",
    compsize: 6,
    // colors: ["blue", "lightblue"],
    champions: ["Aphelios", "Rell", "Rengar", "Dragon Tyrant Swain"],
  },
  {
    id: 2,
    name: "Bard Trait",
    img: "Bard Trait.png",
    compsize: 1,
    // colors: ["rgb(56, 6, 104)", "rgb(56, 6, 104)", "black"],
    champions: ["Bard"],
  },
  {
    id: 3,
    name: "Lagoon",
    img: "Lagoon.png",
    compsize: 12,
    // colors: ["rgb(85, 85, 85)", "lightgrey"],
    champions: [
      "Malphite",
      "Taliyah",
      "Kai'Sa",
      "Zac",
      "Seraphine",
      "Zeri",
      "Nilah",
      "Sohm",
    ],
  },
  {
    id: 4,
    name: "Cavalier",
    img: "Cavalier.png",

    compsize: 6,
    // colors: ["rgb(214, 175, 0)", "rgb(168, 137, 0)"],
    champions: ["Sejuani", "Lillia", "Rell", "Nunu", "Hecarim"],
  },
  {
    id: 5,
    name: "Prodigy",
    img: "Prodigy.png",
    compsize: 3,
    // colors: ["teal", "teal", "black"],
    champions: ["Nomsy"],
  },
  {
    id: 6,
    name: "Dragon",
    img: "Dragon.png",
    compsize: 5,
    // colors: ["rgb(230, 108, 51)", "rgb(230, 108, 51)", "black"],
    champions: [
      "Zippy",
      "Nomsy",
      "Sy'fen",
      "Idas",
      "Daeja",
      "Shi Oh Yu",
      "Sohm",
      "Dragon Tyrant Swain",
      "Ao Shin",
      "Aurelion Sol",
      "Shyvana",
      "Terra",
    ],
  },
  {
    id: 7,
    name: "Dragonmancer",
    img: "Dragonmancer.png",
    compsize: 8,
    // colors: ["gray", "gray", "black"],
    champions: ["Karma", "Sett", "Kai'Sa", "Lee Sin", "Volibear", "Yasuo"],
  },
  {
    id: 8,
    name: "Guardian",
    img: "Guardian.png",
    compsize: 6,
    // colors: ["rgb(83, 37, 37)", "rgb(83, 37, 37)", "black"],
    champions: ["Leona", "Nasus", "Braum", "Zac", "Rakan", "Idas"],
  },
  {
    id: 9,
    name: "Guild",
    img: "Guild.png",
    compsize: 8,
    // colors: ["yellow", "#e1ad01", "black"],
    champions: ["Sejuani", "Twitch", "Zippy", "Bard", "Jayce"],
  },
  {
    id: 10,
    name: "Evoker",
    img: "Evoker.png",
    compsize: 4,
    // colors: ["rgb(114, 17, 57)", "rgb(99, 11, 48)", "black"],
    champions: ["Zyra", "Seraphine", "Aurelion Sol"],
  },
  {
    id: 11,
    name: "Jade",
    img: "Jade.png",
    compsize: 9,
    // colors: ["blue", "lightblue", "white"],
    champions: [
      "Karma",
      "Wukong",
      "Jax",
      "Gnar",      
      "Shi Oh Yu",
      "Soraka",
    ],
  },
  {
    id: 12,
    name: "Monolith",
    img: "Monolith.png",
    compsize: 3,
    champions: ["Terra"],
  },
  {
    id: 13,
    name: "Mage",
    img: "Mage.png",
    compsize: 9,
    champions: [
      "Taliyah",
      "Vladmir",
      "Lillia",
      "Lux",
      "Heimerdinger",
      "Sylas",
      "Zoe",
      "Sohm",
    ],
  },
  {
    id: 14,
    name: "Mirage",
    img: "Mirage.png",
    compsize: 8,
    champions: ["Leona", "Yone", "Nunu", "Yasuo", "Daeja"],
  },
  {
    id: 15,
    name: "Mystic",
    img: "Mystic.png",
    compsize: 5,
    champions: ["Rakan", "Seraphine", "Shi Oh Yu", "Bard"],
  },
  {
    id: 16,
    name: "Ragewing",
    img: "Ragewing.png",
    compsize: 8,
    champions: ["Senna", "Sett", "Rakan", "Hecarim", "Xayah", "Shyvana"],
  },
  {
    id: 17,
    name: "Scalescorn",
    img: "Scalescorn.png",
    compsize: 6,
    champions: ["Braum", "Lillia", "Diana", "Olaf"],
  },
  {
    id: 18,
    name: "Assassin",
    img: "Assassin.png",
    compsize: 6,
    champions: ["Qiyana", "Diana", "Rengar", "Nilah"],
  },
  {
    id: 19,
    name: "Shapeshifter",
    img: "Shapeshifter.png",
    compsize: 4,
    champions: ["Nidalee", "Gnar", "Jayce", "Shyvana"],
  },
  {
    id: 20,
    name: "Shimmerscale",
    img: "Shimmerscale.png",
    compsize: 9,
    champions: ["Nasus", "Jax", "Volibear", "Idas", "Zoe"],
  },
  {
    id: 21,
    name: "Spell Thief",
    img: "Spell Thief.png",
    compsize: 1,
    champions: ["Zoe"],
  },
  {
    id: 22,
    name: "Starcaller",
    img: "Starcaller.png",
    compsize: 1,
    champions: ["Soraka"],
  },
  {
    id: 23,
    name: "Swiftshot",
    img: "Swiftshot.png",
    compsize: 6,
    champions: ["Ezreal", "Twitch", "Varus", "Xayah"],
  },
  {
    id: 24,
    name: "Tempest",
    img: "Tempest.png",
    compsize: 8,
    champions: ["Ezreal", "Qiyana", "Lee Sin", "Graves", "Ao Shin"],
  },
  {
    id: 25,
    name: "Bruiser",
    img: "Bruiser.png",
    compsize: 8,
    champions: ["Malphite", "Skarner", "Jax", "Olaf", "Sylas", "Sy'fen"],
  },
  {
    id: 26,
    name: "Warrior",
    img: "Warrior.png",
    compsize: 6,
    champions: ["Wukong", "Yone", "Olaf", "Pantheon", "Yasuo"],
  },
  {
    id: 27,
    name: "Whispers",
    img: "Whispers.png",
    compsize: 8,
    champions: ["Zyra", "Sylas", "Pantheon", "Sy'fen"],
  },
  {
    id: 28,
    name: "Cannoneer",
    img: "Cannoneer.png",
    compsize: 6,
    champions: ["Senna", "Aphelios", "Zeri", "Graves"],
  },
]

export default Comps2
